var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      ref: "popover2",
      attrs: {
        placement: "bottom-start",
        trigger: "click",
        "visible-arrow": false,
        "popper-class": "poppev-condition-name",
      },
      model: {
        value: _vm.visiblePopOver,
        callback: function ($$v) {
          _vm.visiblePopOver = $$v
        },
        expression: "visiblePopOver",
      },
    },
    [
      _c(
        "div",
        {
          class: [
            "condition-menu",
            JSON.stringify(_vm.selectedLevel2Tip) != "{}"
              ? "condition-menu-tips"
              : "",
            _vm.isSearch ? "condition-menu-search" : "",
          ],
        },
        [
          _c(
            "el-scrollbar",
            {
              ref: "clickselect",
              staticClass: "fx-none",
              attrs: {
                "wrap-class": "clickselect-scroll_wrap level1-scroll-wrap",
              },
            },
            [
              _c(
                "ul",
                {
                  staticClass: "level1-menu",
                  class: { "level-menu-hidde": _vm.isSearch },
                },
                _vm._l(_vm.menuList, function (item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "condition-option",
                      class: {
                        active: item.checked,
                        disabled: item.inUse == 2 ? true : false,
                      },
                      on: {
                        mouseenter: function () {
                          item.inUse != 2 ? _vm.level1OptionClick(item) : ""
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "condition-title" }, [
                        _vm._v(_vm._s(item.label) + " "),
                        item.isNew2
                          ? _c("i", { staticClass: "level1-hot" })
                          : _vm._e(),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
          _c(
            "el-scrollbar",
            {
              ref: "clickselect",
              staticClass: "fx-none",
              class: { "level2-isSearch-wrap": _vm.isSearch },
              attrs: {
                "wrap-class": "clickselect-scroll_wrap level2-scroll-wrap",
              },
            },
            [
              _c(
                "ul",
                {
                  staticClass: "level2-menu clearfix",
                  class: {
                    "level2-only": _vm.isSearch,
                    "leve2-height-mini":
                      _vm.isSearch && _vm.level2Menu.length == 0,
                  },
                },
                [
                  _c(
                    "li",
                    {
                      staticClass: "result-title-default",
                      class: { "result-title": _vm.isSearch },
                    },
                    [_vm._v("搜索结果：")]
                  ),
                  _vm._l(_vm.level2Menu, function (item, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        staticClass: "condition-option2",
                        class: {
                          active: item.checked,
                          disabled: item.inUse == 2 ? true : false,
                        },
                        on: {
                          click: function () {
                            item.inUse != 2 ? _vm.level2OptionClick(item) : ""
                          },
                          mouseenter: function () {
                            item.inUse != 2 ? _vm.level2OptionTip(item) : ""
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "conBox" }, [
                          item.icon == 1
                            ? _c("img", {
                                attrs: {
                                  src: require("@/assets/new-icon.svg"),
                                  alt: "",
                                },
                              })
                            : _vm._e(),
                          _c("span", { staticClass: "condition-title" }, [
                            _vm._v(_vm._s(item.keyword)),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  _c(
                    "li",
                    {
                      staticClass: "no-result-default",
                      class: {
                        "level2-only": _vm.isSearch,
                        "no-result": _vm.isSearch && _vm.level2Menu.length == 0,
                      },
                    },
                    [_vm._v("未找到匹配项")]
                  ),
                ],
                2
              ),
            ]
          ),
          JSON.stringify(_vm.selectedLevel2Tip) != "{}"
            ? _c(
                "el-scrollbar",
                {
                  ref: "clickselect",
                  staticClass: "fx-none",
                  attrs: {
                    "wrap-class": "clickselect-scroll_wrap level2-scroll-wrap",
                  },
                },
                [
                  _c("div", { staticClass: "level2-menu menu-tips" }, [
                    _c("div", { staticClass: "tips-item" }, [
                      _c("p", { staticClass: "title" }, [_vm._v("维度说明")]),
                      _c("p", [
                        _vm._v(_vm._s(_vm.selectedLevel2Tip["description"])),
                      ]),
                    ]),
                    _c("div", { staticClass: "tips-item" }, [
                      _c("p", { staticClass: "title" }, [_vm._v("应用场景")]),
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(_vm.selectedLevel2Tip["scene"]),
                        },
                      }),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          class: [
            "condition-name",
            !_vm.inputValue && _vm.isClickOne ? "isEmpty" : "",
          ],
          attrs: { slot: "reference" },
          slot: "reference",
        },
        [
          _c("el-input", {
            attrs: { placeholder: "请选择条件", size: "small" },
            on: { focus: _vm.focus, blur: _vm.blur, input: _vm.filterName },
            model: {
              value: _vm.inputValue,
              callback: function ($$v) {
                _vm.inputValue = $$v
              },
              expression: "inputValue",
            },
          }),
          _c("div", { staticClass: "err-empty" }, [_vm._v("请选择查询条件")]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }